import { Box, Container, Grid, Typography } from "@mui/material";

import useResponsive from "@/hooks/useResponsive";
import BecomeDealerButton from "./components/BecomeDealerButton";
import JoinNetworkShowCase from "./components/JoinNetworkShowCase";

const JoinNetwork = () => {
  const isMobile = useResponsive("down", "md");
  return (
    <Box
      component="section"
      pt={{ xs: 0, md: 4, lg: 12.5 }}
      pb={{ xs: 7.5, md: 8, lg: 12.5 }}
    >
      <Container>
        <Grid container spacing={{ xs: 1, lg: 3, xl: 6 }}>
          {/* Title */}
          <Grid item xs={12} md={5.5} lg={6}>
            <Typography color="text.primary" variant="h1" mb={{ xs: 2, md: 3 }}>
              Join Our Installer Network
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              mb={{ xs: 4, md: 6, lg: 7.5 }}
            >
              If your customers will benefit from industry-leading tracking solutions, join our installer network and start earning commissions with every sale.
            </Typography>

            {!isMobile && <BecomeDealerButton />}
          </Grid>

          {/* Grid showcase for desktop */}
          {!isMobile && (
            <Grid item xs={12} md={6.5} lg={6}>
              <JoinNetworkShowCase />
            </Grid>
          )}
        </Grid>
      </Container>

      {/* Slider showCase for mobile */}
      {isMobile && (
        <>
          <JoinNetworkShowCase />
          <Container>
            <BecomeDealerButton />
          </Container>
        </>
      )}
    </Box>
  );
};

export default JoinNetwork;
